export default "__VITE_ASSET__7efc309b__"